import 'slick-carousel';
import objectFitImages from 'object-fit-images';
import AOS from 'aos';
(function () {
    $('.modal.open-on-load').modal('show')

    // image failsafe for migrated images
    $.each($('image[src^="~/IHA"]'),
        function (index, value) {
            var $this = $(this);
            var src = $this.attr('src').toLowerCase();
            var newUrl = "https://ihasitestage.blob.core.windows.net/cmssite/iha/media/ihasite/";
            src = src.replace("~/iha/media/ihasite/", newUrl);
            $this.attr('src', src);
        });

    $('div.search-bar-header').find('input[type=text]').keypress(function (e) {
        if (e.which === 13) {
            $('div.search-bar-header').find('input[type=submit]').click();
            return false;
        }
    });
    $('.btn-site-search').on('click tap', function (e) {
        e.preventDefault();
        $('.search-bar-header').slideToggle();
        var $this = $(this);
        $this.toggleClass("active");
        $this.find('span').toggleClass('fa-search fa-close');
    });
    $('#btnSearch').on('click tap', function (e) {
        e.preventDefault();
        var query = $('#txtWord').val();
        location.href = '/search?searchText=' + query;
    })
    // Share Modal
    $(document).on('click tap', 'a.share-icon',
        function (e) {
            e.preventDefault();
            var $modal = $('#shareModal');
            $modal.find('#shareUrl').val($(this).attr('href'));
            $modal.modal('toggle');
        });
    $('button#shareSend').on('click tap',
        function (e) {
            var $modal = $('#shareModal');
            var to = $modal.find('#shareTo').val();
            var message = $modal.find('#shareMessage').val();
            var url = $modal.find('#shareUrl').val();
            url += '&to=' + to;
            url += '&message=' + message;

            var data = {
                to: to,
                message: message
            }

            $.post(url, data);
            $modal.modal('toggle');
        });

    // Mobile Nav
    $('#nav-toggle').on('click tap', function () {
        $('html').toggleClass('mobile-nav-visible');
        var $this = $(this);
        $this.toggleClass("active");
        $this.find('i').toggleClass('fa-bars fa-close');
    });
    $('#mobile-nav-close').on('click tap touchmove', function () {
        $('html').removeClass('mobile-nav-visible');
    });
    $('#mobile-nav-close-btn').on('click tap touchmove', function () {
        $('html').removeClass('mobile-nav-visible');
    });

    // Make object-fit css work in IE
    if ($('.container-left img').length > 0) {
        objectFitImages('.container-left img');
    }

    // slick
    if ($('div').hasClass('more-info-slick-items')) {
        $('.more-info-slick-items').slick({
            mobileFirst: true,
            centerMode: true,
            dots: true,
            arrows: false,
            responsive: [{
                breakpoint: 767,
                settings: 'unslick'
            }]
        });
    };

    $('.events-slider').slick({
        dots: true,
        slidesToShow: 1,
        arrows: false,
    });
    // Animate on Scroll
    $(window).on('load', function () {
        AOS.refresh();
    });
    $(document).ready(function () {
        AOS.init({
            disable: 'mobile',
            delay: 400
        });
    });

    // Mobile Nav Accordion
    $('.mobile-accordion').on('click tap', function (e) {
        if ($(this).parent().has('ul')) {
            e.preventDefault();
        }

        if (!$(this).hasClass('open')) {
            // hide any open menus and remove all other classes
            $('ul.nav-drawer').slideUp();
            $('.mobile-accordion').removeClass('open');

            // open menu and add the open class
            $(this).next('ul').slideDown();
            $(this).addClass('open');
        }

        else if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next('ul').slideUp();
        }

        // toggle between plus and minus icons
        var collapsed = $(this).find('i').hasClass('fa-plus');

        $('.mobile-accordion').find('i').removeClass('fa-minus');

        $('.mobile-accordion').find('i').addClass('fa-plus');

        if (collapsed) {
            $(this).find('i').toggleClass('fa-plus fa-minus');
        }

    });

    $('#tabs-horizontal').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion           
        width: 'auto', //auto or any custom width
        fit: true,   // 100% fits in a container
        closed: 'accordion', // Close the panels on start, the options 'accordion' and 'tabs' keep them closed in there respective view types
        tabidentify: 'vert', // The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
        activetab_bg: '#ffffff', // background color for active tabs in this group
        inactive_bg: '#ffffff', // background color for inactive tabs in this group
    });

    $('.trigger-panel-date').on('click tap', function () {
        var $this = $(this);
        $this.find('.panel-options-date').slideToggle(400);
        $this.find('.fa').toggleClass('fa-angle-down fa-angle-up');
    });

    $('.trigger-panel-category').on('click tap', function () {
        var $this = $(this);
        $this.find('.panel-options-category').slideToggle(400);
        $this.find('.fa').toggleClass('fa-angle-down fa-angle-up');
    });

    var $myProfileUpdateButton = $('.my-profile-update');
    if ($myProfileUpdateButton.length > 0) {
        $myProfileUpdateButton.val('Update');
    }

    $(function () {
        $('#forgotPasswordForm').submit(function (event) {
            event.preventDefault();
            debugger;
            $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                data: $(this).serialize(),
                success: function (response) {
                    debugger;
                    if (response.success) {
                        $('#successMessage').html(response.message).show();
                        $('#forgotPasswordFormContainer').html('');

                    } else {
                        $('#successMessage').html(response.message).show();
                    }
                },
                error: function (xhr, status, error) {
                    $('#successMessage').html('There was an error handling your request.').show();
                }
            });
        });
    });
})();